import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Tabs1 from '@mui/material/Tabs';
import Tab1 from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Card, Form, Button, Alert, Container, Row, Col, Spinner, Tab, Tabs } from "react-bootstrap";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useProjectName } from "../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import { getToken } from "../../utils/auth";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, md: 3 } }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function QrCodeRequestPage() {
  const [value, setValue] = useState(0);
  const [qrCodeRequest, setQrCodeRequest] = useState("");
  const [loading, setLoading] = useState(false);
  const [reservations, setReservations] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [youtube, setYoutube] = useState("");
  const { t } = useTranslation();
  const projectName = useProjectName();

  const handleChange = (_, newValue) => setValue(newValue);

  const handleDropdown = async () => {
    try {
      const token = getToken();
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/default-setting`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setYoutube(response?.data?.data?.isDefaultSettingsExist?.tutorialLinkForPlatinumQrc?.[0]);
    } catch (error) {
      console.error("Failed fetching dropdown:", error);
    }
  };

  useEffect(() => {
    handleDropdown();
    fetchReservations();
  }, []);

  const handleQrCodeRequest = (e) => setQrCodeRequest(e.target.value);

  const submitQrCodeRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/identifier-reservation/request`,
        { identifier: qrCodeRequest },
        {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        }
      );
      fetchReservations();
      toast.success(response?.data?.message || "QR Code request sent successfully!");
      setQrCodeRequest("");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send QR Code request.");
    } finally {
      setLoading(false);
    }
  };

  const fetchReservations = async () => {
    setFetching(true);
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/identifier-reservation/request?page=1&limit=100`,
        {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        }
      );
      setReservations(response.data?.data?.reservations || []);
    } catch {
      toast.error("Failed to fetch QR Code reservations.");
    } finally {
      setFetching(false);
    }
  };

  const capitalizeFirstLetter = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);

  return (
    <div style={{ width: "100%", padding: 0, margin: 0 }}>
      <Toaster position="top-right" reverseOrder={false} />
                      <Container>

      {/* <Row className="g-0 m-0 p-0"> */}
        <Col xs={12} className="">
          <Box sx={{ width: "100%", m: 0}}>
            {/* Header */}
            <div
              style={{
                fontWeight: "bold",
                marginTop:"10px",
                fontSize: "20px",
                color: "#0d6efd",
                textAlign: "center",
              }}
            >
              {t("platinum_qrc")}
            </div>

            <Box sx={{px:1}}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 10,
                flexWrap: "wrap",
              }}
            >
              {youtube && (
                <a
                  href={youtube}
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary"
                  style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png"
                    alt="YouTube Icon"
                    style={{ width: 25, height: 18, marginRight: 5 }}
                  />
                  {t("watch_how_it_works")}
                </a>
              )}
            </Box>

            {/* Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2, px:1, mb:1 }}>
              <Tabs1
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="QR Tabs"
              >
                <Tab1 label={t("request_qrc")} {...a11yProps(0)} />
                <Tab1 label={t("requested_qrc")} {...a11yProps(1)} />
              </Tabs1>
            </Box>

            {/* Panel 1: Request Form */}
            <CustomTabPanel value={value} index={0}>
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <Form onSubmit={submitQrCodeRequest}>
                    <p style={{ fontSize: 16 }}>
                      {t("gain_access_message")}
                      <br />
                      {t("submission_review_note")}
                    </p>
                    <Form.Group>
                      <Form.Label>{t("enter_qr_code_id_store")}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g., 123-QR-456"
                        value={qrCodeRequest}
                        onChange={handleQrCodeRequest}
                        required
                      />
                      <Form.Text muted>{t("accuracy_ensure_note")}</Form.Text>
                    </Form.Group>
                    <Button
                      type="submit"
                      className="btn btn-primary w-100 mt-3"
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner as="span" animation="border" size="sm" />
                      ) : (
                        t("submit_request_button")
                      )}
                    </Button>
                  </Form>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 10,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#f8d7da",
                        color: "#721c24",
                        padding: "5px 10px",
                        borderRadius: 5,
                        fontSize: 12,
                      }}
                    >
                      {t("qr_code_applicability_note")} {t("qr_hero")}
                    </div>
                  </div>
                </Card.Body>
              </Card>

              {/* FAQ */}
              <h4 className="mt-4">{t("faq_section_title")}</h4>
              {[
                { q: "faq_what_is_qr_code", a: "faq_qr_code_explanation" },
                { q: "faq_processing_time_question", a: "faq_processing_time_answer" },
                { q: "faq_support_question", a: "faq_support_answer" },
              ].map((item, idx) => (
                <Card key={idx} className="shadow-sm border-0 mb-3">
                  <Card.Body>
                    <strong>{t(item.q)}</strong>
                    <p>{t(item.a)}</p>
                  </Card.Body>
                </Card>
              ))}

              <div className="text-center mt-3">
                <h5 className="text-muted">{t("need_help_title")}</h5>
                <p>{t("need_help_message")}</p>
              </div>
            </CustomTabPanel>

            {/* Panel 2: Requested List */}
            <CustomTabPanel value={value} index={1}>
              {fetching ? (
                <div className="text-center my-3">
                  <Spinner animation="border" />
                </div>
              ) : reservations?.length > 0 ? (
                reservations.map((r) => (
                  <Card key={r?._id} className="shadow-sm border-0 mb-3">
                    <Card.Body>
                      <h5>
                        {t("identifier_label")}: {r?.identifier}
                      </h5>
                      <div>{t("query_status_label")}: {capitalizeFirstLetter(r?.status)}</div>
                      {r.status !== "requested" && <div>{t("price")}: ${r?.price}</div>}
                      <div>
                        {t("requested_by_label")}: {r?.userId?.firstName} {r?.userId?.lastName}
                      </div>
                      <div>
                        {t("requested_at_label")}:{" "}
                        {new Date(r?.createdAt).toLocaleString()}
                      </div>
                    </Card.Body>
                  </Card>
                ))
              ) : (
                <div>{t("no_qr_codes_message")}</div>
              )}
            </CustomTabPanel>
          </Box>
        </Col>
      {/* </Row> */}
                      </Container>

    </div>
  );
}
